import { Experiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'

function useNewFlightUpsellExperiment(canShowFlightUpsell: boolean): boolean {
  const { isAnyVariant } = useExperiment(Experiments.croNewFlightUpsellTest, {
    canActivate: canShowFlightUpsell,
  })

  return isAnyVariant
}

export default useNewFlightUpsellExperiment
